import { blockType } from "../constants";
import { LinksBlockSchema } from "../schema";
import { Links } from "../types";
import { create as createLinkCard } from "../../LinksCard/lib/create";

export const create: Links["create"] = (initialConfig, children) => {
  return LinksBlockSchema.parse({
    type: blockType,
    config: {
      ...initialConfig,
      headerTitle: initialConfig?.headerTitle ?? "Links",
      style: {
        ...initialConfig?.style,
        width: initialConfig?.style?.width ?? "medium",
        alignment: initialConfig?.style?.alignment ?? "center",
      },
    },
    children: children?.length ? children : [createLinkCard()],
  });
};
